import { JuryAbout } from "../../components/juryAbout/juryAbout.component"
import { JuryMemberCard } from "../../components/juryMemberCard/juryMemberCard.component"
import { JuryProfileCard } from "../../components/juryProfileCard/juryProfileCard.component"
import profileIcon from '../../assets/images/profile-male.svg'
import { JuryMemberList } from "../juryMemberList/juryMemberList.component"
import { useSelector } from "react-redux"
import logo from '../../assets/images/new-logo.png'

export const JuryDetails = () => {
    const juryProfile = useSelector(state => state.juryAbout)

    return (
        <>
            <div className="app-content content">
                <div className="content-overlay" />
                <div className="header-navbar-shadow" >
                <img src={logo} className="d-none d-lg-block" alt="img" />
                </div>
                <div className="content-wrapper">
                    <div className="content-body">
                        <div className="row">
                            <div className="col-12 col-lg-3">
                                <JuryProfileCard name={juryProfile.name} designation={juryProfile.designation} />
                                <JuryMemberList />
                            </div>
                            <JuryAbout about={juryProfile.about} />
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}